import { FormContainer } from 'react-hook-form-mui';
import { useHistory } from 'react-router-dom';
import { settingsRoutes } from '../../../../../routes';
import {
    CreateAiSmartReplyPlanRequest,
    buildCreateAiSmartReplyPlanRequest,
} from '../../../../../sic-lib/api/ai/types/Ai';
import { useAiCreateSmartReplyPlan } from '../../../../../sic-lib/api/hooks/useAiSmartReply';
import { aiCreateSmartReplyPlanDefaults } from '../../../../../sic-lib/defaults';
import { DrawerCommon } from '../../../../Shared/Drawer/DrawerCommon';
import { CreateSmartReplyPlanFormControls } from './CreateSmartReplyPlanFormControls';

interface Props {
    isOpen: boolean;
    handleClose: () => void;
}

export function CreateSmartReplyPlanDrawer({ isOpen, handleClose }: Props) {
    const history = useHistory();
    const {
        mutateAsync: createPlan,
        isPending: isLoading,
        isError,
        error,
        isSuccess,
    } = useAiCreateSmartReplyPlan();

    const handleCreate = async (formValues: CreateAiSmartReplyPlanRequest) => {
        await createPlan(buildCreateAiSmartReplyPlanRequest(formValues), {
            onSuccess: newPlan => {
                history.push(settingsRoutes.setBuildSmartReplyPlan(newPlan.planId));
            },
        });
    };

    return (
        <DrawerCommon
            open={isOpen}
            title="Create SmartReply Plan"
            handleOnClose={handleClose}
            width="800px"
        >
            <FormContainer<CreateAiSmartReplyPlanRequest>
                defaultValues={{ ...aiCreateSmartReplyPlanDefaults }}
                mode="all"
                onSuccess={handleCreate}
            >
                <CreateSmartReplyPlanFormControls
                    isLoading={isLoading}
                    isError={isError}
                    isSuccess={isSuccess}
                    error={error}
                />
            </FormContainer>
        </DrawerCommon>
    );
}
